<template>
  <div class="perfect-bu-config" v-loading="loading">
    <ContentHeader :showBack="true" />
    <div class="content-container">
      <div class="content-header">
        <h4>主题信息</h4>
        <!-- v-if="tradePerfectThemeDefineDTO.themeStatus !== 900" -->
        <!-- <div>
          <el-button v-if="tradePerfectThemeDefineDTO.publishStatus === 1" size="mini" type="danger" @click="goConfiguration()">修改</el-button>
          <el-button v-if="tradePerfectThemeDefineDTO.publishStatus === 1 && tradePerfectThemeDefineDTO.themeStatus > 0" size="mini" type="danger" @click="handleDisable()">禁用</el-button>
          <el-button v-if="tradePerfectThemeDefineDTO.publishStatus === 0" size="mini" type="success" @click="handleOpen()">启用</el-button>
        </div> -->
      </div>
      <div class="content">
        <div class="content-box">
          <div class="left">
            <div class="row">
              <div class="content-left">主题名称</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.themeName}}</div>
            </div>
            <div class="row">
              <div class="content-left">活动时间</div>
              <div
                class="content-right"
              >{{tradePerfectThemeDefineDTO.startDate | parseTime('{y}-{m}-{d}')}} 至 {{tradePerfectThemeDefineDTO.endDate | parseTime('{y}-{m}-{d}')}}</div>
            </div>
            <div class="row">
              <div class="content-left">陈列追踪方式</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.trackTypeNameScope}}</div>
            </div>
          </div>
          <div class="right">
            <div class="row">
              <div class="content-left">渠道</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.channelName}}</div>
            </div>
            <div class="row">
              <div class="content-left">所属BU</div>
              <div class="content-right">{{tradePerfectThemeDefineDTO.orgName}}</div>
            </div>
            <div class="row">
              <div class="content-left">执行周数</div>
              <div
                v-if="tradePerfectThemeDefineDTO.execWeekChooseType==='01'"
                class="content-right"
              >{{tradePerfectThemeDefineDTO.execWeekMin+' - '+tradePerfectThemeDefineDTO.execWeekMax}}周</div>
              <div v-else class="content-right">{{tradePerfectThemeDefineDTO.execWeekScope}}</div>
            </div>
          </div>
        </div>
        <div class="row" v-if="bonusBeerScope && bonusBeerScope.length">
          <div class="content-left">赠酒SKU</div>
          <div class="content-right content-skuRight">
            <span v-for="item in bonusBeerScope" :key="item.skuCode">{{item.skuName}}</span>
          </div>
        </div>
        <div class="row">
          <div class="content-left">费用返还方式</div>
          <div class="content-right">{{tradePerfectThemeDefineDTO.bonusTypeNameScope}}</div>
        </div>
      </div>
      <div v-if="activeName !== ''">
        <!-- <h4>执行任务信息</h4> -->
        <!-- tab栏 -->
        <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
          <template v-for="item in taskCheckedList">
            <el-tab-pane v-if="item.checked" :key="item.key" :label="item.title" :name="item.title"></el-tab-pane>
          </template>
        </el-tabs>
        <!-- 选项卡 -->
        <div v-show="activeName==='堆箱任务'">
          <PerfectBuConfigDesign
            v-show="boxObj.mixinPackScopeList && boxObj.mixinPackScopeList.length > 0"
            ref="boxTask"
            class="tab-content"
            style="margin-bottom: 25px;"
            :type="'view'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="boxObj.mixinPackScopeList || []"
            :regionListByBu="regionListByBu"
          ></PerfectBuConfigDesign>
          <PerfectBuCombinationDesign
            v-show="boxObj.mixinDisplayScopeList && boxObj.mixinDisplayScopeList.length > 0"
            ref="boxCombination"
            :type="'view'"
            class="tab-content"
            :class="boxObj.mixinPackScopeList && boxObj.mixinPackScopeList.length > 0?'tab-combination':''"

            :title="'堆箱组合陈列套餐'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="boxObj.mixinDisplayScopeList || []"
            :customBrandList="customBrandList"
            :regionListByBu="regionListByBu"
          ></PerfectBuCombinationDesign>
        </div>
        <div v-show="activeName==='货架任务'">
          <PerfectBuFreezerDesign
            v-show="goodsShelfObj.mandatoryScopeList && goodsShelfObj.mandatoryScopeList.length > 0"
            class="tab-content"
            ref="goodsShelfTask"
            style="margin-bottom: 25px;"
            :type="'view'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="goodsShelfObj.mandatoryScopeList || []"
            :customBrandList="customBrandList"
            :regionListByBu="regionListByBu"
          ></PerfectBuFreezerDesign>
          <PerfectBuCombinationDesign
            v-show="goodsShelfObj.mixinDisplayScopeList && goodsShelfObj.mixinDisplayScopeList.length > 0"
            ref="goodsShelfCombination"
            :type="'view'"
            class="tab-content"
            :class="goodsShelfObj.mandatoryScopeList && goodsShelfObj.mandatoryScopeList.length > 0?'tab-combination':''"
            :title="'货架组合陈列套餐'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="goodsShelfObj.mixinDisplayScopeList || []"
            :customBrandList="customBrandList"
            :regionListByBu="regionListByBu"
          ></PerfectBuCombinationDesign>
        </div>
        <div v-show="activeName==='冰柜任务'">
          <PerfectBuFreezerDesign
            v-show="freezerObj.mandatoryScopeList && freezerObj.mandatoryScopeList.length > 0"
            class="tab-content"
            ref="freezerTask"
            style="margin-bottom: 25px;"
            :type="'view'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="freezerObj.mandatoryScopeList || []"
            :customBrandList="customBrandList"
            :regionListByBu="regionListByBu"
          ></PerfectBuFreezerDesign>
          <PerfectBuCombinationDesign
            v-show="freezerObj.mixinDisplayScopeList && freezerObj.mixinDisplayScopeList.length > 0"
            ref="freezerCombination"
            :type="'view'"
            class="tab-content"
            :class="freezerObj.mandatoryScopeList && freezerObj.mandatoryScopeList.length > 0?'tab-combination':''"
            :title="'冰柜组合陈列套餐'"
            :originThemeDefineDTO="originThemeDefineDTO"
            :primaryData="freezerObj.mixinDisplayScopeList || []"
            :customBrandList="customBrandList"
            :regionListByBu="regionListByBu"
          ></PerfectBuCombinationDesign>
        </div>
      </div>
      <div class="content-container">
        <div class="content-header">
          <h4>操作记录</h4>
        </div>
      <div class="content-table">
        <el-table :data="tradePerfectThemeDefineDTO.commonProcessRecordDTOList" border style="width: 100%">
          <el-table-column label="操作人" align="center">
            <template #default="scope">
              {{scope.row.employeeLevelName + '-' + scope.row.processClientName}}
            </template>
          </el-table-column>
          <el-table-column prop="processActionName" label="操作" align="center"></el-table-column>
          <el-table-column prop="processRemark" label="备注" align="center"></el-table-column>
          <el-table-column prop="createDate" label="时间" align="center">
            <template #default="scope">
              <div>{{scope.row.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import PerfectBuConfigDesign from '../components/perfect-bu-config-design'
import PerfectBuCombinationDesign from '../components/perfect-bu-combination-design'
import PerfectBuFreezerDesign from '../components/perfect-bu-freezer-design'
export default {
  name: 'perfect-bu-config',
  components: {
    ContentHeader,
    PerfectBuConfigDesign,
    PerfectBuCombinationDesign,
    PerfectBuFreezerDesign
  },
  data () {
    return {
      themeDefineId: '',
      regionListByBu: [],
      originThemeDefineDTO: {},
      tradePerfectThemeDefineDTO: {},
      boxObj: {}, // 修改堆箱默认数据
      goodsShelfObj: {}, // 修改货架默认数据
      freezerObj: {}, // 修改冰柜默认数据
      customBrandList: [], // 子品牌对应放入品牌数组中
      taskCheckedList: [],
      activeName: '堆箱任务',
      bonusBeerScope: []
    }
  },
  watch: {
    // 勾选任务
    taskCheckedList: {
      deep: true,
      immediate: true,
      handler () {
        for (let i = 0; i < this.taskCheckedList.length; i++) {
          if (this.taskCheckedList[i].checked) {
            this.activeName = this.taskCheckedList[i].title
            return
          }
        }
      }
    }
  },
  computed: {
  },
  created () {
    this.$store.dispatch('getDictByName', 'tradePerfectMandatorySpecsMap')
    this.$store.dispatch('getDictByName', 'tradePerfectScopeDetailSpecMap')
    this.themeDefineId = this.$route.query.themeDefineId
    this.getBuThemeDefineInfo()
  },
  methods: {
    // 获取默认数据
    getBuThemeDefineInfo () {
      this.loading = true
      let params = { themeDefineId: this.themeDefineId }
      tradeApi.getBuThemeDefineInfo(params).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.originThemeDefineDTO = res.data.resultData.originThemeDefineDTO || []
          this.tradePerfectThemeDefineDTO = res.data.resultData.tradePerfectThemeDefineDTO || []
          this.taskCheckedList = []
          if (this.tradePerfectThemeDefineDTO.taskTypeScope === '') {
            this.activeName = ''
          }
          this.tradePerfectThemeDefineDTO.taskTypeScope.split(',').forEach(item => {
            if (item === '01') {
              this.taskCheckedList.push({ title: '堆箱任务', key: item, checked: true, showTask: true })
            }
            if (item === '02') {
              this.taskCheckedList.push({ title: '货架任务', key: item, checked: true, showTask: true })
            }
            if (item === '03') {
              this.taskCheckedList.push({ title: '冰柜任务', key: item, checked: true, showTask: true })
            }
          })
          if (this.tradePerfectThemeDefineDTO.bonusBeerScope === '') {
            this.bonusBeerScope = []
          } else {
            this.bonusBeerScope = JSON.parse(this.tradePerfectThemeDefineDTO.bonusBeerScope)
          }
          // 组建中已配置的数据
          this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList.forEach(item => {
            if (item.taskType === '01') {
              this.boxObj = item
            }
            if (item.taskType === '02') {
              this.goodsShelfObj = item
            }
            if (item.taskType === '03') {
              this.freezerObj = item
            }
          })
          let orgCode = this.tradePerfectThemeDefineDTO.orgCode ? this.tradePerfectThemeDefineDTO.orgCode : this.orgList[0].orgCode
          this.getRegionListByBu(orgCode)
          // 处理匹配品牌与子品牌
          let brandList = Object.assign([], this.originThemeDefineDTO.brandList)
          let subBrandList = Object.assign([], this.originThemeDefineDTO.subBrandList)
          if (brandList.length && subBrandList.length) {
            brandList.forEach(brand => {
              this.$set(brand, 'subBrandList', [])
              subBrandList.forEach(subBrand => {
                if (brand.abiBrandId === subBrand.parentBrandId) {
                  brand.subBrandList.push(subBrand)
                }
              })
            })
          }
          this.customBrandList = brandList
          if (this.tradePerfectThemeDefineDTO) {
            this.$nextTick(() => {
              this.$refs.boxTask.setInfo()
              this.$refs.boxCombination.setInfo()
              this.$refs.goodsShelfTask.setInfo()
              this.$refs.goodsShelfCombination.setInfo()
              this.$refs.freezerTask.setInfo()
              this.$refs.freezerCombination.setInfo()
            })
          }
        }
      })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取区域列表
    getRegionListByBu (code) {
      let params = {
        buCode: code
      }
      this.$store
        .dispatch('getRegionListByBu', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.regionListByBu = res.data.resultData.regionList || []
            this.regionListByBu.forEach(item => {
              item.orgName = item.orgName.substring(0, item.orgName.indexOf('|'))
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    goConfiguration () {
      this.$router.push({ name: 'perfect-bu-config', query: { themeDefineId: this.themeDefineId, type: 'update', status: this.tradePerfectThemeDefineDTO.themeStatus } })
    },
    handleDisable () {
      this.$prompt('请输入禁用原因！', '是否禁用该活动', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        inputPattern: /\S/,
        inputErrorMessage: '请输入禁用原因'
      })
        .then(({ value }) => {
          let params = { themeDefineId: this.themeDefineId, processRemark: value }
          tradeApi.perfectDisabled(params)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.getBuThemeDefineInfo()
                this.$message.success('禁用成功')
              }
            })
            .catch(() => {
              this.$message.error('禁用失败')
            })
        }).catch(() => { })
    },
    handleOpen () {
      this.$prompt('请输入启用原因！', '是否启用该活动', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(({ value }) => {
          let params = { themeDefineId: this.themeDefineId, processRemark: value }
          tradeApi.perfectEnable(params)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.getBuThemeDefineInfo()
                this.$message.success('启用成功')
              }
            })
            .catch(() => {
              this.$message.error('启用失败')
            })
        }).catch(() => { })
    },
    handleClick (tab, event) {
    }
  }
}
</script>

<style lang="scss" scoped>
.clearStyle {
  line-height: 0px;
}
.content-container {
  h4 {
    font-weight: bold;
    font-size: 20px;
  }
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: space-between;
}
.content {
  // height: 220px;
  font-size: 14px;
  margin: 30px auto;
  padding: 0 40px;
  background-color: #fff;
  border-radius: 10px;
  line-height: 50px;
  .content-box {
    display: flex;
    .left {
      width: 50%;
    }
    .right {
      width: 50%;
    }
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right:15px;
    }
    .content-left {
      width: 130px;
      // height: 50px;
    }
    .content-right{
      flex-basis: 70%;
      white-space:normal;
      word-break:break-all;
      word-wrap:break-word;
    }
    .content-skuRight {
      width: 900px!important;
    }
  }
}
.tabs {
  margin-top: 20px;
}
// 任务多选样式
.task {
  display: flex;
  // justify-content: space-around;
  align-content: center;
  margin: 20px 20px;
  border-radius: 10px;

  .task-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    line-height: 45px;
    color: #333;
    overflow: hidden;
    text-align: center;

    .task-content {
      align-content: center;
      width: 30%;
      margin: 0 10px;
      height: 90px;
      background-color: #fff;
      border-radius: 10px;
      .task-title {
        font-size: 16px;
      }
    }
  }
}
.taskCheckbox {
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 50px;
    width: 25px;
    height: 25px;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox.is-bordered.is-checked {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep.el-checkbox__inner::after {
    height: 15px;
    left: 10px;
    top: 2px;
  }
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input .el-checkbox__inner {
    height: 25px;
    width: 25px;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input:hover .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
}
// // 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  margin: -15px auto 0;
  padding: 20px 20px;
  background-color: #fff;
  border-radius: 0px 10px 10px 10px;
}
.tab-combination {
  border-radius: 10px !important;
}
// 加号
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 12px 0 0 0;
  border-radius: 10px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}

.operate {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
.content-table {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
}
// 必填
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}
</style>
